import React from "react";

const Home_Sched = () => {
  return (
    <section className="container schedbg text-dark py-5">
      <h2 className="text-center fw-bold mb-4">Classes Schedule</h2>
      <div className="container">
        <div className="table-responsive">
          <h2 className="text-center fw-bold mb-4">CHISWICK</h2>
          <table className="table table-bordered text-center">
            <thead className="table-dark">
              <tr>
                {["Monday", "Tuesday", "Thursday"].map(
                  (day) => (
                    <th key={day}>{day}</th>
                  ),
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>Adults</strong>
                  <br />
                  7.30pm to 8.30pm
                </td>
                <td>
                  <strong>Adults</strong>
                  <br />
                  7.30pm to 8.30pm
                </td>
                <td>
                  <strong>Adults</strong>
                  <br />
                  7.30pm to 8.30pm
                </td>
              </tr>
              <tr>
                <td>-</td>
                <td>
                  <strong>Children</strong>
                  <br />
                  6.30pm to 7.30pm
                </td>
                <td>
                  <strong>Children</strong>
                  <br />
                  6.30pm to 7.30pm
                </td>
              </tr>
            </tbody>
          </table>
          <h2 className="text-center fw-bold mb-4">ACTON</h2>
          <table className="table table-bordered text-center">
            <thead className="table-dark">
              <tr>
                {["Wednesday", "Saturday", "Sunday"].map(
                  (day) => (
                    <th key={day}>{day}</th>
                  ),
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>Adults</strong>
                  <br />
                  7.00pm to 8.00pm
                </td>
                <td>
                  <strong>Adults</strong>
                  <br />
                  12noon to 1pm
                </td>
                <td>
                  <strong>Adults</strong>
                  <br />
                  12noon to 1pm
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Children</strong>
                  <br />
                  6.00pm to 7.00pm
                </td>
                <td>
                  <strong>Children</strong>
                  <br />
                  11am to 12noon
                </td>
                <td>
                  <strong>Children</strong>
                  <br />
                  12noon to 1pm
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Home_Sched;
